var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70372 1.39109L0.833501 4.26842C0.811147 4.29083 0.793426 4.31743 0.781351 4.34669C0.769275 4.37595 0.763081 4.4073 0.763123 4.43896C0.763164 4.47061 0.76944 4.50195 0.781591 4.53118C0.793743 4.56041 0.811533 4.58696 0.833945 4.60931C0.856358 4.63166 0.882953 4.64938 0.912214 4.66146C0.941475 4.67353 0.972827 4.67973 1.00448 4.67969C1.03614 4.67965 1.06747 4.67337 1.0967 4.66122C1.12593 4.64907 1.15248 4.63128 1.17483 4.60886L3.87439 1.9022L6.57395 4.60886C6.61909 4.65413 6.68037 4.6796 6.7443 4.67969C6.80823 4.67977 6.86957 4.65445 6.91483 4.60931C6.9601 4.56416 6.98557 4.50289 6.98566 4.43896C6.98574 4.37503 6.96042 4.31368 6.91528 4.26842L4.04506 1.39109C4.02268 1.36862 3.99608 1.35079 3.96679 1.33863C3.9375 1.32646 3.9061 1.3202 3.87439 1.3202C3.84268 1.3202 3.81128 1.32646 3.78199 1.33863C3.7527 1.35079 3.7261 1.36862 3.70372 1.39109Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.6fcf1de8.svg";
export { ForwardRef as ReactComponent };